export default __webpack_public_path__ + "static/media/pin-72.ab96f0c2.svg";